module.exports = __webpack_public_path__ + "img/save.bd40f588.svg";